export type WarningPopupProps = {
  title: string;
  description: string;
  onCancel: () => void;
  onConfirm: () => void;
};

function WarningPopup({
  title,
  description,
  onCancel,
  onConfirm,
}: WarningPopupProps) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="min-w-[350px] max-w-[350px] rounded-md bg-white p-4 md:min-w-[500px] md:max-w-[500px] md:p-6">
        <h1 className="mb-4 text-2xl font-bold">{title}</h1>
        <p className="mb-4">{description}</p>
        <div className="flex justify-end gap-2">
          <button
            onClick={onCancel}
            className="rounded-md bg-red-500 px-4 py-2 text-white"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="rounded-md border border-red-500 px-4 py-2 text-red-500"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}

export default WarningPopup;
